import { FunctionalComponentOptions, VNode } from 'vue';

type Props = {
  nodes: VNode | VNode[];
};

const removeSlotAssociation = (v: VNode): VNode => {
  if (v && v.data) {
    v.data.slot = undefined;
  }

  return v;
};
const VNodes: FunctionalComponentOptions<Props> = {
  name: 'VNodes',
  functional: true,
  render: (_, { props }) =>
    Array.isArray(props.nodes)
      ? props.nodes.map(removeSlotAssociation)
      : removeSlotAssociation(props.nodes)
};

export default VNodes;
